import { Injectable } from '@angular/core';

@Injectable() //'VG_UTILS'
export class VgUtilsService {
	/**
	 * Inspired by Paul Irish
	 * https://gist.github.com/paulirish/211209
	 * @returns {number}
	 */
	public getZIndex(): number {
		const tags = document.getElementsByTagName('*');

		return Array.from(tags)
			.reduce((zIndex: number, tag: Element) => {
				const elementZIndex: number = parseInt(window.getComputedStyle(tag)['z-index'], 10);

				return elementZIndex > zIndex ?
					elementZIndex + 1 :
					zIndex;
			}, 1);
	}

	/**
	 * Test the browser's support for HTML5 localStorage.
	 * @returns {boolean}
	 */
	public supportsLocalStorage(): boolean {
		try {

			const testKey: string = 'videogular-test-key';
			const storage: Storage = window.localStorage;

			if (!storage) {
				return false;
			}

			storage.setItem(testKey, '1');
			storage.removeItem(testKey);

			return true;
		} catch (e) {
			return false;
		}
	}
}
